<template>
  <EditorToolbar
    v-bind="propsToPass"
    :show-comments="showComments"
    v-on="{ ...eventHandlers, buttonClick }"
    @click.capture="onClickCapture"
  >
    <template #more>
      <slot name="more" />
    </template>
  </EditorToolbar>
</template>

<script>
import { mapState } from 'pinia';
import { useDocumentEditor } from '@/stores/document/editor';
import { useDocumentEditorToolbar } from '@/stores/document/editorToolbar';
import { useTracking } from '@/stores/tracking/tracking';
import EditorToolbar from './EditorToolbar.vue';

export default {
  name: 'EditorToolbarContainer',
  components: { EditorToolbar },
  props: {
    showComments: { type: Boolean, default: false },
  },
  computed: {
    ...mapState(useDocumentEditorToolbar, ['propsToPass', 'eventHandlers']),
  },
  methods: {
    buttonClick(event) {
      this.eventHandlers.buttonClick(event);
      useTracking().editorToolbarClick({ id: event.id });
    },

    onClickCapture() {
      const { focusId } = useDocumentEditor();

      // restore editor focus
      setTimeout(() => {
        useDocumentEditor().updateFocus(focusId);
      }, 300);
    },
  },
};
</script>
